export default __webpack_public_path__ + "static/media/IMG_6387.6349eec4.jpeg";